import { render, staticRenderFns } from "./UploadTreesDetail.vue?vue&type=template&id=16ffcbb0&scoped=true"
import script from "./UploadTreesDetail.vue?vue&type=script&lang=js"
export * from "./UploadTreesDetail.vue?vue&type=script&lang=js"
import style0 from "./UploadTreesDetail.vue?vue&type=style&index=0&id=16ffcbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ffcbb0",
  null
  
)

export default component.exports